(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    document.querySelectorAll('[data-product-section]').forEach(init);
  });

  function init(section) {
    if (section.dataset.hoiProductInitialized === 'true') return;
    section.dataset.hoiProductInitialized = 'true';

    const productEl = section.querySelector('[data-product-json]');
    if (!productEl) return;

    let product;
    try {
      product = JSON.parse(productEl.textContent);
    } catch (error) {
      console.error('Home of Interior: invalid product JSON.', error);
      return;
    }

    const panels = [...section.querySelectorAll('[data-media-panel]')];
    const thumbs = [...section.querySelectorAll('[data-media-id]')];
    let mediaIndex = Math.max(0, panels.findIndex((panel) => !panel.hidden));

    function showMedia(id) {
      panels.forEach((panel, index) => {
        const active = String(panel.dataset.mediaPanel) === String(id);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) mediaIndex = index;
      });
      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(id));
      });
      section.dispatchEvent(new CustomEvent('hoi:media-changed'));
    }

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));
    section.querySelector('[data-gallery-prev]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (panels.length) showMedia(panels[(mediaIndex - 1 + panels.length) % panels.length].dataset.mediaPanel);
    });
    section.querySelector('[data-gallery-next]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (panels.length) showMedia(panels[(mediaIndex + 1) % panels.length].dataset.mediaPanel);
    });


    function setupHoverZoom() {
      const stageWrap = section.querySelector('.hoi-stage-wrap');
      const zoomPanel = section.querySelector('[data-hover-zoom-panel]');
      const zoomResult = section.querySelector('[data-hover-zoom-result]');
      const precisePointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      if (!stageWrap || !zoomPanel || !zoomResult || !precisePointer.matches) return;

      let activeButton = null;
      let activeImage = null;
      let activeLens = null;
      let frame = 0;
      let pointerX = 0;
      let pointerY = 0;

      function getActiveSource() {
        return section.querySelector('[data-media-panel]:not([hidden]) [data-hover-zoom-source]');
      }

      function stopZoom() {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        stageWrap.classList.remove('hoi-hover-zoom-active');
        zoomPanel.setAttribute('aria-hidden', 'true');
        zoomPanel.removeAttribute('style');
        zoomResult.removeAttribute('style');
        if (activeLens) activeLens.removeAttribute('style');
        activeButton = null;
        activeImage = null;
        activeLens = null;
      }

      function drawZoom() {
        frame = 0;
        if (!activeButton || !activeImage || !activeLens) return;

        const buttonRect = activeButton.getBoundingClientRect();
        const imageRect = activeImage.getBoundingClientRect();
        const panelRect = zoomResult.getBoundingClientRect();
        if (!buttonRect.width || !buttonRect.height || !imageRect.width || !imageRect.height || !panelRect.width || !panelRect.height) return;

        const naturalWidth = activeImage.naturalWidth || imageRect.width;
        const naturalHeight = activeImage.naturalHeight || imageRect.height;
        const imageRatio = naturalWidth / naturalHeight;
        const boxRatio = imageRect.width / imageRect.height;
        const fit = section.querySelector('[data-media-stage]')?.dataset.fit || 'contain';

        let renderedWidth = imageRect.width;
        let renderedHeight = imageRect.height;
        let offsetX = 0;
        let offsetY = 0;

        if (fit === 'contain') {
          if (imageRatio > boxRatio) {
            renderedHeight = imageRect.width / imageRatio;
            offsetY = (imageRect.height - renderedHeight) / 2;
          } else {
            renderedWidth = imageRect.height * imageRatio;
            offsetX = (imageRect.width - renderedWidth) / 2;
          }
        } else if (fit === 'cover') {
          if (imageRatio > boxRatio) {
            renderedWidth = imageRect.height * imageRatio;
            offsetX = (imageRect.width - renderedWidth) / 2;
          } else {
            renderedHeight = imageRect.width / imageRatio;
            offsetY = (imageRect.height - renderedHeight) / 2;
          }
        }

        const localX = Math.max(offsetX, Math.min(pointerX - imageRect.left, offsetX + renderedWidth));
        const localY = Math.max(offsetY, Math.min(pointerY - imageRect.top, offsetY + renderedHeight));
        const zoom = Math.max(2, panelRect.width / Math.max(1, renderedWidth * 0.5));
        const lensWidth = Math.min(renderedWidth, panelRect.width / zoom);
        const lensHeight = Math.min(renderedHeight, panelRect.height / zoom);
        const lensLeft = Math.max(offsetX, Math.min(localX - lensWidth / 2, offsetX + renderedWidth - lensWidth));
        const lensTop = Math.max(offsetY, Math.min(localY - lensHeight / 2, offsetY + renderedHeight - lensHeight));
        const focusX = ((lensLeft - offsetX) + lensWidth / 2) / renderedWidth;
        const focusY = ((lensTop - offsetY) + lensHeight / 2) / renderedHeight;

        activeLens.style.width = lensWidth + 'px';
        activeLens.style.height = lensHeight + 'px';
        activeLens.style.left = (imageRect.left - buttonRect.left + lensLeft) + 'px';
        activeLens.style.top = (imageRect.top - buttonRect.top + lensTop) + 'px';

        zoomResult.style.backgroundImage = 'url("' + activeButton.dataset.zoomSrc + '")';
        const backgroundWidth = renderedWidth * zoom;
        const backgroundHeight = renderedHeight * zoom;
        const backgroundX = (panelRect.width / 2) - (focusX * backgroundWidth);
        const backgroundY = (panelRect.height / 2) - (focusY * backgroundHeight);
        zoomResult.style.backgroundSize = backgroundWidth + 'px ' + backgroundHeight + 'px';
        zoomResult.style.backgroundPosition = backgroundX + 'px ' + backgroundY + 'px';
      }

      function scheduleDraw(event) {
        pointerX = event.clientX;
        pointerY = event.clientY;
        if (!frame) frame = requestAnimationFrame(drawZoom);
      }

      function positionZoomPanel() {
        const stageRect = stageWrap.getBoundingClientRect();
        const gap = 16;
        const availableWidth = Math.max(280, window.innerWidth - stageRect.right - gap - 12);
        const panelWidth = Math.min(540, availableWidth);
        zoomPanel.style.left = 'calc(100% + ' + gap + 'px)';
        zoomPanel.style.top = '0px';
        zoomPanel.style.width = panelWidth + 'px';
        zoomPanel.style.height = stageRect.height + 'px';
      }

      function startZoom(button, event) {
        const image = button.querySelector('img');
        const lens = button.querySelector('[data-hover-zoom-lens]');
        if (!image || !lens || !button.dataset.zoomSrc) return;
        activeButton = button;
        activeImage = image;
        activeLens = lens;
        pointerX = event.clientX;
        pointerY = event.clientY;
        positionZoomPanel();
        stageWrap.classList.add('hoi-hover-zoom-active');
        zoomPanel.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(drawZoom);
      }

      section.querySelectorAll('[data-hover-zoom-source]').forEach((button) => {
        button.addEventListener('mouseenter', (event) => {
          if (button === getActiveSource()) startZoom(button, event);
        });
        button.addEventListener('mousemove', scheduleDraw);
        button.addEventListener('mouseleave', stopZoom);
      });

      section.addEventListener('hoi:media-changed', stopZoom);
      window.addEventListener('resize', stopZoom, { passive: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === section) stopZoom();
      });
    }

    setupHoverZoom();

    function selectedOptions() {
      return [...section.querySelectorAll('[data-option-position]')].map((fieldset) => {
        const select = fieldset.querySelector('[data-option-select]');
        return select ? select.value : fieldset.querySelector('[data-option-radio]:checked')?.value;
      });
    }

    function findVariant() {
      const values = selectedOptions();
      return product.variants.find((variant) => variant.options.every((option, index) => option === values[index]));
    }

    function money(cents) {
      const format = (window.RexwoodTheme && window.RexwoodTheme.moneyFormat) || '£{{amount}}';
      const value = (cents / 100).toFixed(2);
      return format
        .replace(/{{\s*amount_no_decimals[^}]*}}/, Math.round(cents / 100))
        .replace(/{{\s*amount[^}]*}}/, value);
    }

    const floorSelect = section.querySelector('[data-floor-charge-select]');
    const floorError = section.querySelector('[data-floor-charge-error]');
    const dynamicCheckout = section.querySelector('[data-dynamic-checkout]');

    function selectedFloorCharge() {
      if (!floorSelect) return { label: '', cents: 0, variantId: '' };
      const option = floorSelect.options[floorSelect.selectedIndex];
      return {
        label: floorSelect.value,
        cents: Number(option?.dataset?.chargeCents || 0),
        variantId: String(option?.dataset?.chargeVariantId || '')
      };
    }

    function setFloorError(message) {
      if (!floorError) return;
      floorError.textContent = message || '';
      floorError.hidden = !message;
    }

    function updateFloorAwarePrices(variant) {
      if (!variant) return;
      const floor = selectedFloorCharge();
      const price = section.querySelector('[data-product-price]');
      if (price) {
        const compare = variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price + floor.cents
          : 0;
        price.innerHTML =
          (compare ? '<s>' + money(compare) + '</s> ' : '') +
          '<strong>' + money(variant.price + floor.cents) + '</strong>';
      }
      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(variant.price + floor.cents);

      // Shopify accelerated checkout cannot atomically add the separate paid fee line.
      // Keep it available for the two £0 choices, but hide it while a paid floor is selected.
      if (dynamicCheckout) dynamicCheckout.hidden = floor.cents > 0;
      setFloorError('');
    }

    function update() {
      const variant = findVariant();
      if (!variant) return;

      const hidden = section.querySelector('[data-variant-id]');
      if (hidden) hidden.value = variant.id;

      updateFloorAwarePrices(variant);

      const stock = section.querySelector('[data-stock-status]');
      if (stock) {
        stock.textContent = variant.available ? 'In stock, ready to ship' : 'Currently out of stock';
        stock.className = 'hoi-stock ' + (variant.available ? 'is-in' : 'is-out');
      }

      const add = section.querySelector('[data-add-button]');
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? (add.dataset.availableText || 'Add to cart') : (add.dataset.soldOutText || 'Sold out');
      }

      const sticky = section.querySelector('[data-sticky-add]');
      if (sticky) sticky.disabled = !variant.available;
      const stickyPrice = section.querySelector('[data-sticky-price]');

      const sku = section.querySelector('[data-product-sku]');
      if (sku) sku.textContent = variant.sku || 'N/A';

      if (variant.featured_media) showMedia(variant.featured_media.id);
      history.replaceState({}, '', section.dataset.url + '?variant=' + variant.id);
    }

    section.querySelectorAll('[data-option-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const label = select.closest('fieldset')?.querySelector('[data-selected-label]');
        if (label) label.textContent = select.value;
        update();
      });
    });

    section.querySelectorAll('[data-option-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const label = radio.closest('fieldset')?.querySelector('[data-selected-label]');
        if (label) label.textContent = radio.value;
        update();
      });
    });

    floorSelect?.addEventListener('change', () => {
      const variant = findVariant();
      if (variant) updateFloorAwarePrices(variant);
    });

    // Ensure initial dynamic-checkout visibility and price are floor-aware.
    if (floorSelect) {
      const initialVariant = findVariant();
      if (initialVariant) updateFloorAwarePrices(initialVariant);
    }

    const quantityInput = section.querySelector('[data-quantity] input');
    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (quantityInput) quantityInput.value = Math.max(1, (+quantityInput.value || 1) - 1);
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (quantityInput) quantityInput.value = (+quantityInput.value || 1) + 1;
    });

    const form = section.querySelector('[data-product-form]');
    const addButton = section.querySelector('[data-add-button]');

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;

        const originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding…';

        try {
          const variant = findVariant();
          if (!variant) throw new Error('Please select an available product option.');

          const quantity = Math.max(1, Number(quantityInput?.value || 1));
          const floor = selectedFloorCharge();
          const groupId = floor.cents > 0
            ? 'hoi-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9)
            : '';

          if (floor.cents > 0 && !floor.variantId) {
            const message = 'This paid Floor Charge is not configured yet. Please choose Ground Floor or Upper Floor with Lift, or configure the Floor charge product in the theme editor.';
            setFloorError(message);
            throw new Error(message);
          }

          const furnitureProperties = { 'Floor Charges': floor.label };
          if (groupId) furnitureProperties['_Floor Charge Group'] = groupId;

          const items = [{
            id: variant.id,
            quantity: quantity,
            properties: furnitureProperties
          }];

          if (floor.cents > 0) {
            items.push({
              id: Number(floor.variantId),
              quantity: 1,
              properties: {
                '_Floor Charge Group': groupId,
                '_Floor Charge Item': 'true',
                '_Floor Charge For': product.title,
                'Floor Charges': floor.label
              }
            });
          }

          const response = await fetch((window.RexwoodTheme?.routes?.cartAddUrl || '/cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'Unable to add this product to the cart.');
          }

          const cartResponse = await fetch((window.RexwoodTheme?.routes?.cartJsonUrl || '/cart.js'), {
            headers: { Accept: 'application/json' }
          });
          const cart = await cartResponse.json();

          document.dispatchEvent(new CustomEvent('hoi:cart-updated', {
            detail: { cart: cart, open: true, message: 'Added to cart' }
          }));
        } catch (error) {
          console.error(error);
          const toast = document.querySelector('#toast');
          const toastMessage = document.querySelector('#toastMsg');
          if (toastMessage) toastMessage.textContent = error.message;
          if (toast) {
            toast.classList.add('show');
            setTimeout(() => toast.classList.remove('show'), 3500);
          }
        } finally {
          const currentVariant = findVariant();
          addButton.disabled = currentVariant ? !currentVariant.available : false;
          addButton.textContent = currentVariant && !currentVariant.available
            ? (addButton.dataset.soldOutText || 'Sold out')
            : (addButton.dataset.availableText || originalText || 'Add to cart');
        }
      });
    }

    section.querySelector('[data-sticky-add]')?.addEventListener('click', () => form?.requestSubmit());

    section.querySelectorAll('[data-detail-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-detail-tab]').forEach((item) => item.classList.toggle('is-active', item === button));
        section.querySelectorAll('[data-detail-panel]').forEach((panel) => {
          const active = panel.dataset.detailPanel === button.dataset.detailTab;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });

    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImage = section.querySelector('[data-lightbox-image]');
    const mobileLightboxQuery = window.matchMedia('(max-width: 767px)');
    let lightboxScrollY = 0;
    let lightboxOriginalParent = null;
    let lightboxOriginalNextSibling = null;

    function lockMobileLightboxScroll() {
      lightboxScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lightboxScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockMobileLightboxScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, lightboxScrollY);
    }

    section.querySelectorAll('[data-open-lightbox]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!image || !lightbox || !lightboxImage) return;
        lightboxImage.src = image.currentSrc || image.src;

        if (mobileLightboxQuery.matches && lightbox.parentNode !== document.body) {
          lightboxOriginalParent = lightbox.parentNode;
          lightboxOriginalNextSibling = lightbox.nextSibling;
          document.body.appendChild(lightbox);
          lockMobileLightboxScroll();
        } else {
          document.body.style.overflow = 'hidden';
        }

        lightbox.hidden = false;
        document.body.classList.add('hoi-lightbox-open');
      });
    });

    function closeLightbox() {
      if (lightbox) {
        lightbox.hidden = true;
        document.body.classList.remove('hoi-lightbox-open');

        if (mobileLightboxQuery.matches && lightboxOriginalParent) {
          unlockMobileLightboxScroll();
          if (lightboxOriginalNextSibling && lightboxOriginalNextSibling.parentNode === lightboxOriginalParent) {
            lightboxOriginalParent.insertBefore(lightbox, lightboxOriginalNextSibling);
          } else {
            lightboxOriginalParent.appendChild(lightbox);
          }
          lightboxOriginalParent = null;
          lightboxOriginalNextSibling = null;
        } else {
          document.body.style.overflow = '';
        }
      }
    }

    section.querySelector('[data-close-lightbox]')?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    const questionModal = section.querySelector('[data-question-modal]');
    section.querySelector('[data-open-question]')?.addEventListener('click', () => {
      if (questionModal) questionModal.hidden = false;
    });
    section.querySelector('[data-close-question]')?.addEventListener('click', () => {
      if (questionModal) questionModal.hidden = true;
    });
    questionModal?.addEventListener('click', (event) => {
      if (event.target === questionModal) questionModal.hidden = true;
    });

    const wishlistButton = section.querySelector('[data-product-wishlist]');
    if (wishlistButton) {
      const key = 'homeofinterior_wishlist';
      const handle = wishlistButton.dataset.productHandle;
      const productItem = {
        id: String(product.id),
        handle: handle,
        title: product.title,
        url: section.dataset.url || ('/products/' + handle),
        image: product.featured_image || '',
        price: product.price || 0
      };

      function normalizeWishlist(raw) {
        if (!Array.isArray(raw)) return [];
        return raw.map((item) => {
          if (typeof item === 'string' || typeof item === 'number') {
            return { id: String(item), handle: String(item), title: '', url: '', image: '', price: 0 };
          }
          return item && typeof item === 'object' ? item : null;
        }).filter(Boolean);
      }

      function getWishlist() {
        try {
          const primary = JSON.parse(localStorage.getItem(key));
          if (Array.isArray(primary)) return normalizeWishlist(primary);
          return normalizeWishlist(JSON.parse(localStorage.getItem('rexwood_wishlist')) || []);
        } catch (error) {
          return [];
        }
      }

      function saveWishlist(items) {
        try {
          localStorage.setItem(key, JSON.stringify(items));
          localStorage.setItem('rexwood_wishlist', JSON.stringify(items));
          document.dispatchEvent(new CustomEvent('hoi:wishlist-updated', { detail: { items: items } }));
        } catch (error) {
          console.warn('Wishlist storage is unavailable.', error);
        }
      }

      function isSaved(items) {
        return items.some((item) => String(item.handle || item.id) === String(handle) || String(item.id) === String(product.id));
      }

      function refreshWishlist() {
        const items = getWishlist();
        const active = isSaved(items);
        wishlistButton.classList.toggle('is-active', active);
        wishlistButton.textContent = active ? '♥' : '♡';
        wishlistButton.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
        wishlistButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        document.querySelectorAll('[data-wish-badge]').forEach((badge) => {
          badge.textContent = items.length;
          badge.hidden = items.length === 0;
        });
      }

      wishlistButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        let items = getWishlist();
        const active = isSaved(items);
        if (active) {
          items = items.filter((item) => !(String(item.handle || item.id) === String(handle) || String(item.id) === String(product.id)));
        } else {
          items.push(productItem);
        }
        saveWishlist(items);
        refreshWishlist();

        const toast = document.querySelector('#toast');
        const toastMessage = document.querySelector('#toastMsg');
        if (toastMessage) toastMessage.textContent = active ? 'Removed from wishlist' : 'Added to wishlist';
        if (toast) {
          toast.classList.add('show');
          setTimeout(() => toast.classList.remove('show'), 2500);
        }
      });

      refreshWishlist();
    }

    const stickyBar = section.querySelector('[data-sticky-cart]');
    if (stickyBar && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting),
        { threshold: 0 }
      );
      observer.observe(form);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeLightbox();
        if (questionModal) questionModal.hidden = true;
      }
    });
  }
})();
